// Entity types
export type EntityType = "Case" | "Creditor" | "Debtor" | "Bureau" | "Invoice";

// Translation map
export const ENTITY_TRANSLATION_KEYS: Record<EntityType, string> = {
  Case: "US.COLLECTION.COMMON:COMMON.CASE",
  Creditor: "US.COLLECTION.COMMON:COMMON.CREDITOR",
  Debtor: "US.COLLECTION.COMMON:COMMON.AR",
  Bureau: "US.COLLECTION.COMMON:COMMON.BUREAU",
  Invoice: "US.COLLECTION.COMMON:COMMON.INVOICE",
};
